import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { hasProjectFeature } from '../../utils/projectFeatures';
import { AppShell } from './AppShell';
import { WorkspaceTopBar } from './WorkspaceTopBar';

const SECTION_LABEL_KEYS = {
  users: 'usersPanel',
  database: 'databasePanel',
  skills: 'skillsPanel',
  publish: 'publish',
  settings: 'projectSettings'
};

export const WorkspaceLayout = ({
  project,
  children,
  breadcrumbNotice = null,
  workspaceHeader = null,
  backTo,
  backAriaLabel,
  activeSection = null
}) => {
  const { t } = useI18n();
  const projectId = project?.id;
  const workspacePath = projectId ? `/workspace/${projectId}` : '/projects';
  const resolvedBackTo = backTo || workspacePath;
  const resolvedBackLabel =
    backAriaLabel ||
    (resolvedBackTo === '/projects' ? t('backToProjects') : t('backToWorkspace'));

  if (workspaceHeader) {
    return (
      <AppShell
        variant="workspace"
        title={project?.name}
        breadcrumbNotice={breadcrumbNotice}
        workspaceHeader={workspaceHeader}
      >
        {children}
      </AppShell>
    );
  }

  return (
    <AppShell
      variant="workspace"
      title={project?.name}
      breadcrumbNotice={breadcrumbNotice}
      workspaceHeader={
        <WorkspaceTopBar
          project={project}
          backTo={resolvedBackTo}
          backAriaLabel={resolvedBackLabel}
          activeSection={activeSection}
          sectionLabel={activeSection ? t(SECTION_LABEL_KEYS[activeSection] || 'workspace') : null}
          authEnabled={hasProjectFeature(project, 'auth')}
          databaseEnabled={hasProjectFeature(project, 'database')}
        />
      }
    >
      <div className="h-full min-w-0 overflow-x-hidden overflow-y-auto">
        <div className="mx-auto w-full min-w-0 max-w-6xl px-4 py-6 sm:px-6">{children}</div>
      </div>
    </AppShell>
  );
};
